<template>
<div class="main-box">
	<div class="">
		<a-carousel ref="carousel" :dots="false" effect="fade">
			<div class="carousel-item-box">
				<div class="content-box">
					<div class="flex-box">
						<div class="page-title">忘记密码</div>
						<p class="noce">请验证您的邮箱验证码，以进行重置密码</p>
						<a-form-model ref="forgetForm" :model="forgetForm">
							<a-form-model-item prop="email" :rules="{ required: true, message: '请输入验证邮箱', trigger: 'change', }">
								<a-input v-model="forgetForm.email" size="large" placeholder="邮箱"></a-input>
							</a-form-model-item>
							<a-form-model-item prop="msgCode" :rules="{ required: true, message: '请输入验证码', trigger: 'change', }">
								<a-input v-model="forgetForm.msgCode" size="large" type="text" placeholder="验证码">
									<a-button v-loading-btn slot="addonAfter" type="link" style="width: 82px;"
										:disabled="state.smsSendBtn"
										@click.stop.prevent="getCaptcha('forgetForm')"
										v-text="!state.smsSendBtn && '发送'||(state.time+' s')">
									</a-button>
								</a-input>
							</a-form-model-item>
							<a-form-item>
							  <a-button  size="large" type="primary" class="submit-button" :loading="state.signBtn" :disabled="state.signBtn" @click="onStar('forgetForm')">确定</a-button>
							</a-form-item>
						</a-form-model>
					</div>
					<div class="footer-box">
						<router-link class="btn-link" :to="{ name: 'login' }" >去登录</router-link>
					</div>
				</div>
			</div>
			<div class="carousel-item-box">
				<div class="content-box">
					<div class="flex-box">
						<div class="page-title">重置密码</div>
						<p class="noce">正在为 {{forgetForm.email}} 账号重置密码</p>
						<a-form-model ref="passwordForm" :model="passwordForm">
							<a-form-model-item prop="password" :rules="[{ validator: handlePasswordLevel, trigger: 'change'}]" >
								<a-input v-model="passwordForm.password" size="large" placeholder="新密码"></a-input>
							</a-form-model-item>
							<a-form-item>
                
							  <a-button  size="large" type="primary" class="submit-button" :loading="state.submitBtn" :disabled="state.submitBtn" @click="onSubmit('passwordForm')">确定</a-button>
							</a-form-item>
						</a-form-model>
					</div>
					<div class="footer-box">
						<router-link class="btn-link" :to="{ name: 'login' }" >去登录</router-link>
					</div>
				</div>
			</div>
		</a-carousel>
	</div>
</div>
</template>

<script>
// import { getSmsCaptcha } from '@/api/login'
export default{
	data() {
		return {
			forgetForm: {},
			passwordForm: {
				password: ''
			},
			sign: '',
			state: {
			  time: 60,
				signBtn: false,
			  smsSendBtn: false,
			  submitBtn: false,
			}
		}
	},
	methods: {
		handlePasswordLevel (rule, value, callback) {
		  let level = 0
		  // 判断这个字符串中有没有数字
		  if (/[0-9]/.test(value)) level++
		  // 判断字符串中有没有字母
		  if (/[a-zA-Z]/.test(value)) level++
		  if (level >= 2 && value.length>=8) callback()
		  else callback(new Error('长度8-20位，同时包含大小写字母、数字'))
		},
		next() {  // 重置
			this.$refs.carousel.next()
		},
		prev() {  // 返回邮箱验证
			this.$refs.carousel.prev()
		},
		getCaptcha(formName) {  // 获取邮箱验证码
			const { state, forgetForm, $message, $notification } = this
			this.$refs[formName].validateField('email',err => {
				if (!err) {
					state.smsSendBtn = true
					const interval = window.setInterval(() => {
					  if (state.time-- <= 0) {
					    state.time = 60
					    state.smsSendBtn = false
					    window.clearInterval(interval)
					  }
					}, 1000)
					const hide = $message.loading('验证码发送中..', 0)
					// this.$apis.getForgotCode({ account: forgetForm.email, type: 'email' }).then(res => {
					  setTimeout(hide, 1000)
					//   $notification['success']({
					//     message: '提示',
					//     description: res.msg,
					//     duration: 8
					//   })
					// }).catch(err => {
					//   setTimeout(hide, 1)
					//   clearInterval(interval)
					//   state.time = 60
					//   state.smsSendBtn = false
					// 	$notification['error']({
					// 	  message: '错误',
					// 	  description: err.msg || '请求出现错误，请稍后再试',
					// 	  duration: 4
					// 	})
					// })
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		onStar(formName) {
			this.state.signBtn = true
			this.$refs[formName].validate(valid => {
				if(valid) {
					let params = { account: this.forgetForm.email, type: 'email', msgCode: this.forgetForm.msgCode }
          setTimeout(() => {
            this.state.signBtn = false
          }, 3000);
					// this.$apis.forgot(params).then(res => {
					// 	this.sign = res.data.token
					// 	this.$notification['success']({
					// 	  message: '提示',
					// 	  description: res.msg,
					// 	  duration: 8
					// 	})
					// 	this.next()
					// 	this.forgetForm.msgCode = ''
					// }).catch(err => {
					// 	this.$notification['error']({
					// 	  message: '提示',
					// 	  description: err.msg,
					// 	  duration: 8
					// 	})
					// }).finally(() => {this.state.signBtn = false})
				}
				else {
					setTimeout(() => {
					  this.state.signBtn = false
					}, 500)
				}
			})
		},
		onSubmit(formName) {
			this.state.submitBtn = true
			this.$refs[formName].validate(valid => {
				if(valid) {
					let params = {
						account: this.forgetForm.email,
						passWord: this.passwordForm.password,
						type: 'email',
						signature: this.sign
					}
					// this.$apis.setPassword(params).then(res => {
					// 	this.$notification['success']({
					// 	  message: '提示',
					// 	  description: res.msg,
					// 	  duration: 8
					// 	})
					// 	this.$router.push({ path: '/' })
					// }).catch(err => {
					// 	this.$notification['error']({
					// 	  message: '提示',
					// 	  description: err.msg,
					// 	  duration: 8
					// 	})
					// }).finally(() => {
					// 	this.passwordForm.password = ''
						this.state.submitBtn = false
					// })
				} else {
          setTimeout(() => {
            this.state.submitBtn = false
          }, 600)
        }
			})
		},
	}
}
</script>

<style lang="less" scoped>
.main-box{
	width: 100%;
	.carousel-item-box{
		height: calc(100vh - 112px);
		display: flex !important;
		justify-content: center;
		.content-box{
			width: 420px;
			height: 100%;
			display: flex;
			flex-direction: column;
			.flex-box{
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: center;
				padding-bottom: 75px;
			}
			.footer-box{
				width: 100%;
				padding: 24px;
				text-align: center;
				font-size: 12px;
				font-family: PingFang SC;
				font-weight: 500;
				color: #111111;
				letter-spacing: 1px;
				.btn-link{
					color: #0078FF;
					cursor: pointer;
				}
			}
		}
		.page-title{
			font-size: 28px;
			font-family: PingFang SC;
			font-weight: 800;
			line-height: 40px;
			color: #111111;
			margin-bottom: 8px;
		}
		.noce{
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 500;
			color: #333C54;
			margin-bottom: 32px;
		}
	}
}
button.submit-button {
	padding: 0 15px;
	font-size: 16px;
	height: 40px;
	width: 100%;
}
</style>
